import { Effect } from 'types/Effects';
import { ScalingType, SceneItem } from 'types/Scene';

export enum Workspace {
  Artboard = 'artboard',
  ScenesPanel = 'scenesPanel'
}

export type WorkspaceState = {
  current: Workspace;
};

export enum ClipboardDataType {
  Effects = 'effects',
  Scene = 'scene'
}

export type ClipboardData = {
  type: ClipboardDataType;
  effects?: Effect[];
  scene?: SceneItem;
  dimensions?: { width: number; height: number };
  scalingMode?: ScalingType;
  from?: string;
};
